/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const UploadResponse: core.serialization.ObjectSchema<serializers.UploadResponse.Raw, Truvity.UploadResponse> =
    core.serialization.object({
        blobId: core.serialization.property('blob_id', core.serialization.string()),
        timeout: core.serialization.number(),
        uploadUri: core.serialization.property('upload_uri', core.serialization.string()),
    });

export declare namespace UploadResponse {
    export interface Raw {
        blob_id: string;
        timeout: number;
        upload_uri: string;
    }
}
